import React, { useState, useContext } from "react";
import { PhotoManagerContext } from "..";
import { RenameEventModalProps } from "../types";
import toastr from "../../../common/toastr";
import {
  validateName,
  restrictedTermsError
} from "../../../../utils/validateName";

const RenameEvent: React.FC<RenameEventModalProps> = ({
  onClose,
  event,
  onRenameClicked
}) => {
  const [name, setName] = useState<string>(event?.name || "");
  const [loading, setLoading] = useState<boolean>(false);
  const context = useContext(PhotoManagerContext);

  const handleRename = async () => {
    const isValidName = validateName(name);
    if (!isValidName) {
      toastr.error(restrictedTermsError);
      return;
    } else if (!name.trim()) {
      toastr.error("Please enter a valid name");
      return;
    }
    setLoading(true);
    try {
      if (event) await onRenameClicked(event, name);
      onClose();
    } catch (error) {
      console.error(`Error renaming event`, error);
      toastr.error("Failed to rename event. Please try again");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleRename();
    }
  };

  return (
    <div>
      <div id="filter-dialog" className="modal fade in geo-modal" role="dialog">
        <div className="modal-dialog filter-dialog-content ws-create-modal">
          <div className="geo-modal__header">
            <h4>Rename Event</h4>
          </div>
          <button
            type="button"
            className="close"
            onClick={onClose}
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="modal-content">
            <p>Update the event name</p>
            <div className="row geo geo-form geo-form--fw">
              <input
                id="name-input"
                type="text"
                className="geo-form__input ws-geo-input"
                value={name}
                onChange={e => setName(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder={`Enter event name`}
                autoFocus
                disabled={loading}
              />
            </div>
            <div className="modal-footer geo-modal__actions dont-break ws-delete-footer-btns">
              <button
                className="geo-btn geo-btn--secondary geo-btn--caps geo-btn--small rename-btn"
                onClick={handleRename}
                disabled={loading || !name.trim()}
              >
                {loading ? (
                  <div className="loading-spinner">
                    Renaming... <span className="fa fa-spinner fa-spin"></span>
                  </div>
                ) : (
                  "RENAME EVENT"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default RenameEvent;
